export function getdata() {
  let obj = {
    headData:[
      {
        title: '数电票号码',
        prop: 'tes1',
        width: '150',
        issort: true,
        custom:true,
      },{
        title: '单据状态',
        prop: 'tes3',
        width: '100',
        custom:true,
        showFilter: true,
        checkList: ['1', '2'],
        dataList: [
          {
            name: "已开票",
            code: "1"
          }, {
            name: "开票失败",
            code: "2"
          },
        ]
      }, {
        title: '发票类型',
        prop: 'tes4',
        width: '100',
        custom:true,
        checkList: ['1'],
        dataList: [
          {
            name: "电子普票",
            code: "1"
          },
        ]
      }, {
        title: '开票时间',
        prop: 'tes5',
        width: '100',
        issort: true,
      }, {
        title: '价税合计',
        prop: 'tes6',
        width: '100',
        issort: true,
        AmountFormat:true,
      }, {
        title: '购方名称',
        prop: 'tes7',
        width: '100',
        issort: true,
      }, {
        title: '任务批次号',
        prop: 'tes8',
        width: '200',
        issort: true,
      }, {
        title: '最近执行时间',
        prop: 'tes9',
        width: '200',
        issort: true,
      },{
        title: '任务完成时间',
        prop: 'tes10',
        width: '200',
        issort: true,
      },{
        title: '处理状态',
        prop: 'tes11',
        width: '100',
        showFilter: true,
				custom:true,
				checkList: [],
				dataList: [
					{
						name: "是",
						code: "0"
					},
					{
						name: "否",
						code: "1"
					},
				]
      },{
        title: '错误原因',
        prop: 'tes12',
        width: '100',
        issort: true,
      }
    ],
    //页码
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      paginationkey: 0
    },
  }
  return obj
}